export const LPPOLICE = "lppolice";
export const LOCATEPLUS = "locateplus";
export const ENTERSECT = "entersect";

const DEV = "dev";
const TEST = "test";
const PROD = "prod";
const LOCAL = "local";

const getAppName = () => {
  const hostname = window.location.hostname.toLocaleLowerCase();
  if (hostname.indexOf(LOCATEPLUS) !== -1) return LOCATEPLUS;
  if (hostname.indexOf(LPPOLICE) !== -1) return LPPOLICE;
  if (hostname.indexOf(ENTERSECT) !== -1) return ENTERSECT;
  return LOCATEPLUS;
};

export const getApiHost = (env) => {
  if(localStorage.requestUri) return localStorage.requestUri;
  switch (env) {
    case LOCAL:
      return "http://localhost:8030";
    case DEV:
      return "http://dev.combiner.locateplus.com";
    case TEST:
      return "https://test.login.locateplus.com";
    case PROD:
      return "https://combinerstage.locateplus.com";
    default:
      return "http://dev.combiner.locateplus.com";
  }
};

const settings = {
  env: TEST,
  appName: getAppName(),
  apiHost: getApiHost(this.env),
  reqQuestions: 1,
  siteKeys: {
    reset: "6LdybK8sAAAAALRyvwh8IHk0ld5zZh5wZZ_DVotx",
  },
  ssnMask: {
    ShowAll: "SA",
    ShowLastFour: "SL4",
    HideLastFour: "HL4",
    HideAll: "HA",
  },
  dobMask: {
    ShowAll: "SA",
    ShowMonthYear: "SMY",
    ShowYearOnly: "SYO",
    HideAll: "HA",
  },
  viewReports: ["common", "neighbors", "relatives"],
  newMartinTemplate: ["relatives", "neighbors", "nimbuspersons"],
  viewDetailReportRoots: [
    "persons",
    "phonemartins",
    "phoneenhanceds",
    "nimbuspersons",
  ],
  hideCaseManagementAtFormsForReports: [29, 88, 143, 144],
  highlightAddNewBadgeMenus: ["7", "8"],
  hideNoChargePriceReportIds: [29, 88],
  skipMainMenu: [7, 8],
  showAuditMessageReports: [45, 48],
  deniedSearchForms: [50, 65],
  revealSsnReportId: 139,
  phoneNumber: {
    locateplus: "888-746-3463",
    lppolice: "877-482-0101",
    entersect: "877-482-0101",
  },
  searchIconFromName: {
    People: "group",
    Phone: "phone square",
    "Vehicles/Assets": "home",
    "Criminal/Civil": "table",
    Licenses: "drivers license outline",
    Business: "user circle outline",
    "My Account": "briefcase",
  },
  myAccountMenuItem: {
    MenuTitle: "My Account",
    subMenuItems: [
      {
        MenuTitle: "My Searches",
      },
      {
        MenuTitle: "My Cases",
      },
    ],
  },
  comp: [
    "summary",
    "martin",
    "properties",
    "relatives",
    "common",
    "neighbors",
    "emails",
    "media",
  ],
  compPlus: ["compreportresponse", "instantcrim", "emails", "media"],
  compDefaultReportTypes: [
    "ssnverification",
    "addresshistory",
    "commonresidency",
    "crimsec",
    "demo",
    "email",
    "neighbors",
    "properties",
    "relatives",
    "social",
  ],
  defaultSection: {
    sectionName: "namedob",
    displayName: "Name/DOB",
  },
  sectionReports: [
    {
      sectionName: "akas",
      displayName: "AKAs",
    },
    {
      sectionName: "addresshistory",
      displayName: "Address History",
    },
    {
      sectionName: "ssnverification",
      displayName: "SSN Verification",
    },
    {
      sectionName: "associates",
      displayName: "Associates",
    },
    {
      sectionName: "civil",
      displayName: "Bankruptcies, Liens and Judgments",
    },
    {
      sectionName: "bank",
      displayName: "Bankruptcies",
    },
    {
      sectionName: "bankOnly",
      displayName: "Bankruptcies",
    },
    {
      sectionName: "businessAssociations",
      displayName: "Business Associations",
    },
    {
      sectionName: "commonresidency",
      displayName: "Common Residency",
    },
    {
      sectionName: "corporateFilings",
      displayName: "Corporate Filings",
    },
    {
      sectionName: "affiliations",
      displayName: "Corporate Affiliations",
    },
    {
      sectionName: "criminal",
      displayName: "Criminal Records Primary",
    },
    {
      sectionName: "crimsec",
      displayName: "Criminal Records Secondary",
    },
    {
      sectionName: "demo",
      displayName: "Demographics",
    },
    {
      sectionName: "driverLicense",
      displayName: "Driver License",
    },
    {
      sectionName: "email",
      displayName: "Emails",
    },
    {
      sectionName: "employers",
      displayName: "Employers",
    },
    {
      sectionName: "evictions",
      displayName: "Evictions",
    },
    {
      sectionName: "aircraft",
      displayName: "FAA Aircraft",
    },
    {
      sectionName: "faacertificates",
      displayName: "FAA Certificates",
    },
    {
      sectionName: "firearm",
      displayName: "Federal Firearms & Explosives",
    },
    {
      sectionName: "foreclosures",
      displayName: "Foreclosures",
    },
    {
      sectionName: "huntingfishing",
      displayName: "Hunting/Fishing",
    },
    {
      sectionName: "huntingPermits",
      displayName: "Hunting Permits",
    },
    {
      sectionName: "imposters",
      displayName: "Imposters",
    },
    {
      sectionName: "liens",
      displayName: "Liens and Judgments",
    },
    {
      sectionName: "liensOnly",
      displayName: "Liens",
    },
    {
      sectionName: "judgmentsOnly",
      displayName: "Judgments",
    },
    {
      sectionName: "neighbors",
      displayName: "Neighbors Current",
    },
    {
      sectionName: "historicalneighbors",
      displayName: "Neighbors Historical",
    },
    {
      sectionName: "people_at_work",
      displayName: "People At Work",
    },
    {
      sectionName: "pilotLicenses",
      displayName: "Pilot Licenses",
    },
    {
      sectionName: "possibleAssociates",
      displayName: "Possible Associates",
    },
    {
      sectionName: "professionalAssociations",
      displayName: "Professional Associations",
    },
    {
      sectionName: "professionallicenses",
      displayName: "Professional Licenses",
    },
    {
      sectionName: "properties",
      displayName: "Properties",
    },
    {
      sectionName: "pastProperties",
      displayName: "Past Properties",
    },
    {
      sectionName: "propertyForeclosures",
      displayName: "Property Foreclosures",
    },
    {
      sectionName: "propertiesLN",
      displayName: "Property Records",
    },
    {
      sectionName: "propertiessec",
      displayName: "Property Records Secondary",
    },
    {
      sectionName: "propertyTaxes",
      displayName: "Property Taxes",
    },
    {
      sectionName: "relatives",
      displayName: "Relatives",
    },
    {
      sectionName: "social",
      displayName: "Social Media",
    },
    {
      sectionName: "tradeMarks",
      displayName: "Trade Marks",
    },
    {
      sectionName: "ucc",
      displayName: "UCC Filings",
    },
    {
      sectionName: "vehicles",
      displayName: "Vehicles",
    },
    {
      sectionName: "voterregistrations",
      displayName: "Voter Registrations",
    },
    {
      sectionName: "watercrafts",
      displayName: "Watercrafts",
    },
    {
      sectionName: "watchListRecords",
      displayName: "WatchList Records",
    },
    {
      sectionName: "weapon",
      displayName: "Concealed Weapons Permits",
    },
    {
      sectionName: "wikipediaLinks",
      displayName: "Wikipedia Links",
    },
  ],
  addOnReports: [
    {
      sectionName: "addon",
      displayName: "Add On Reports",
    },
    {
      sectionName: "vehiclesaddon",
      displayName: "Motor Vehicles Records",
    },
    {
      sectionName: "mvraddon",
      displayName: "Motor Vehicles Records",
    },
    {
      sectionName: "mvraddonplat",
      displayName: "Motor Vehicles Records",
    },
    {
      sectionName: "vehiclesaddon",
      displayName: "Motor Vehicles Records",
    },
    {
      sectionName: "crimaddon",
      displayName: "Criminal Records",
    },
    {
      sectionName: "bljaddon",
      displayName: "Bankruptcies, Liens and Judgments",
    },
    {
      sectionName: "propaddon",
      displayName: "Property Records",
    },
  ],
  compPlusDefaultReportTypes: [
    "associates",
    "ssnverification",
    "addresshistory",
    "commonresidency",
    "bank",
    "liens",
    "criminal",
    "crimsec",
    "relatives",
    "neighbors",
    "historicalneighbors",
    "properties",
    "driverLicense",
    "watercrafts",
    "akas",
    "affiliations",
    "weapon",
    "firearm",
    "aircraft",
    "faacertificates",
    "foreclosures",
    "voterregistrations",
    "imposters",
    "ucc",
    "people_at_work",
    "email",
    "web",
    "social",
    "professionallicenses",
    "huntingfishing",
  ],
  compSilverDefaultReportTypes: [
    "addresshistory",
    "aircraft",
    "associates",
    "bank",
    "businessAssociations",
    "corporateFilings",
    "criminal",
    "driverLicense",
    "email",
    "employers",
    "evictions",
    "huntingPermits",
    "liens",
    "neighbors",
    "pastProperties",
    "pilotLicenses",
    "possibleAssociates",
    "professionalAssociations",
    "professionallicenses",
    "properties",
    "propertyForeclosures",
    "propertyTaxes",
    "relatives",
    "tradeMarks",
    "ucc",
    "vehicles",
    "voterregistrations",
    "watchListRecords",
    "weapon",
    "wikipediaLinks",
  ],
  compGoldDefaultReportTypes: [
    "addresshistory",
    "aircraft",
    "associates",
    "ssnverification",
    "businessAssociations",
    "corporateFilings",
    "criminal",
    // "driverLicense",
    "email",
    "employers",
    "evictions",
    "huntingPermits",
    // "liens",
    "neighbors",
    "pastProperties",
    "pilotLicenses",
    "possibleAssociates",
    "professionalAssociations",
    "professionallicenses",
    "properties",
    "propertyForeclosures",
    "propertyTaxes",
    "relatives",
    "tradeMarks",
    "ucc",
    "voterregistrations",
    "watchListRecords",
    "weapon",
    "wikipediaLinks",
  ],
  compNewGoldAdditionalReportTypes: [
    "vehicles",
    "liensOnly",
    "judgmentsOnly",
    "bankOnly"
  ],
  controls: [
    {
      name: "radius",
      minValue: 0,
      maxValue: 950,
      stepValue: 5,
    },
    {
      name: "age",
      minValue: 18,
      maxValue: 100,
      stepValue: 1,
    },
  ],
  validationRules: {
    phone: {
      regex: /^\d{3}-\d{3}-\d{4}$/,
      errorMessage: "Please enter a full phone number with areacode",
    },
    ssn: {
      regex: /^\d{3}-\d{2}-\d{4}$/,
      errorMessage: "SSN must be 9 digits",
    },
  },
  controlRules: {
    exactmatchonly: {
      remove: ["fuzzyfirstname", "fuzzylastname"],
    },
    fuzzyfirstname: {
      remove: ["exactmatchonly"],
    },
    fuzzylastname: {
      remove: ["exactmatchonly"],
    },
    fuzzyAddress: {
      hide: ["radius"],
    },
    fuzzyAge: {
      hide: ["age"],
    },
  },
};

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js